import * as Yup from 'yup';

/**
 * @remarks
 * since we need to localize error messages, we pass translation keys
 * from the validation schema and the form-error.messages file will map the keys
 * to localized error messages.
 */

const optionalString = Yup.string().trim();
const requiredString = Yup.string()
  .trim()
  .required('payment.form.validation.required');

const requiredAlphabets = requiredString.test({
  name: 'alphabets',
  test: (value) => /^(\p{Letter}| )+$/u.test(value),
  message: 'payment.form.validation.invalid.chars',
});

export const addressSchema = Yup.object({
  firstName: requiredAlphabets,
  lastName: requiredAlphabets,
  address: requiredString,
  unit: optionalString,
  city: requiredString,
  country: requiredString,
  /**
   * @remarks
   * state can be optionally required depending on the country,
   * so we store state in either state(not required) or stateCode(required)
   * for countries with no states, we store it in state
   * for countries with states, we store it in stateCode
   */
  state: optionalString,
  stateCode: requiredString,
  postalCode: optionalString,
});
